import { render, staticRenderFns } from "./OwnerFreezerDetail.vue?vue&type=template&id=3a327a76&"
import script from "./OwnerFreezerDetail.vue?vue&type=script&lang=js&"
export * from "./OwnerFreezerDetail.vue?vue&type=script&lang=js&"
import style0 from "./OwnerFreezerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports